import React from 'react';
import SalesCallout from './SalesCallout';

interface SalesCalloutReviewsProps {
  ctaPageName: string;
}

type Props = React.FC<React.HTMLAttributes<HTMLAnchorElement> & SalesCalloutReviewsProps>;

const SalesCalloutReviews: Props = ({ className, ctaPageName, ...props }) => {
  return (
    <SalesCallout
      title="Reviews"
      ctaTitle="More Reviews"
      calloutId="sales_callout_reviews"
      ctaPageName={ctaPageName}
      href="/reviews"
      {...props}
      className={`${className ? className : ''}`}
      image={
        <div className="inline-block max-w-full">
          <picture>
            <img
              className="block h-auto max-w-full align-middle"
              width={242}
              height={206}
              loading="lazy"
              src="https://gentux.imgix.net/1557856694_SalesCalloutReviews-image-no-bg-20190514-135749.png?auto=format"
              alt="Brick and mortar stores can’t compete with this quality. Trust us, you can tell. -WeddingWire"
            />
          </picture>
        </div>
      }
    >
      See what everyone is saying about Generation&nbsp;Tux.
    </SalesCallout>
  );
};

export default SalesCalloutReviews;
